import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";
import NumberFormat from "react-number-format";
import CartItem from "./CartItem";

const CartDetails = ({
  items,
  total,
  open,
  onClose,
  onDeleteItem,
  startPaymentWizard,
}) => {
  const renderList = () => {
    return (
      <>
        {items.length === 0 && (
          <Typography
            className="mt-5"
            variant="subtitle1"
            color="textSecondary"
            align="center"
          >
            No se han ingresado items al carrito
          </Typography>
        )}

        <List>
          {items.map((item, index) => (
            <React.Fragment key={`item-${index}`}>
              <CartItem
                index={index}
                item={item}
                onDeleteItem={() => onDeleteItem(item, index)}
              />
              {index + 1 < items.length && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </>
    );
  };

  return (
    <>
      <Hidden mdUp>
        <Drawer
          anchor="right"
          open={open}
          onClose={onClose}
          PaperProps={{
            className: "full-width",
          }}
        >
          <AppBar color="default" className="app-top-bar">
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={onClose}>
                <ArrowBackIcon />
              </IconButton>

              <Typography variant="h6" align="center" className="title">
                Este es tu carrito...
              </Typography>
            </Toolbar>
          </AppBar>

          <div className="drawer-content">{renderList()}</div>

          <AppBar color="default" className={`app-bottom-bar`}>
            <Toolbar className="toolbar">
              <Container maxWidth="sm" className="text-center">
                <Button
                  variant="contained"
                  size="large"
                  onClick={startPaymentWizard}
                >
                  <NumberFormat
                    value={total}
                    thousandSeparator="."
                    decimalSeparator=","
                    prefix="Ir a Pagar ($"
                    suffix=")"
                    displayType={"text"}
                  />
                </Button>
              </Container>
            </Toolbar>
          </AppBar>
        </Drawer>
      </Hidden>

      <Hidden smDown>
        <div className="cart-sticky">
          <Typography className="my-3" variant="h6">
            Carrito
          </Typography>

          <Card className="mb-4">{renderList()}</Card>

          {items.length > 0 && (
            <div className="d-flex justify-content-center">
              <Button
                fullWidth
                size="large"
                variant="contained"
                className="button-radius w-75"
                onClick={startPaymentWizard}
              >
                <NumberFormat
                  value={total}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="Ir a Pagar ($"
                  suffix=")"
                  displayType={"text"}
                />
              </Button>
            </div>
          )}
        </div>
      </Hidden>
    </>
  );
};

export default CartDetails;
